/**
 * Builds ValidationRuleFn from predicate and error message
 *
 * @typedef {import("./types").Predicate} Predicate
 * @typedef {import("./types").ValidationRuleFn} ValidationRuleFn
 * @type {(predicate: Predicate, message: string) => ValidationRuleFn}
 */
// eslint-disable-next-line react/display-name
export const rule = (predicate, message) => (value, form, fieldName) =>
	predicate(value, form, fieldName) ? null : message;
